export default __webpack_public_path__ + "media/images/brighteon-social/tutorial/Brighteon-Social-Configure-Notifications-9f30bae6443cc3faab8cd227103b585f.png";